import {
    getRibbonBottomBarStylingConstants,
    getRibbonTopBarStylingConstants,
    type RibbonBottomBarStylingConstants,
} from 'owa-acui';
import { isSingleLineRibbon } from 'owa-command-ribbon-store/lib/selectors/isSingleLineRibbon';
import { isFeatureEnabled } from 'owa-feature-flags';

export function getRibbonBottomBarStyleConstants(): RibbonBottomBarStylingConstants {
    const isFluentV9Enabled = isFeatureEnabled('mon-ribbon-fluent-v9-ribbon');
    const ribbonType = isSingleLineRibbon() ? 'SingleLine' : 'Multiline';
    if (!isFluentV9Enabled && ribbonType == 'Multiline') {
        return {
            ...getRibbonBottomBarStylingConstants('Multiline'),
            bottomBarHeight: 92,
            groupDividerPadding: {
                ...getRibbonBottomBarStylingConstants('Multiline').groupDividerPadding,
                bottom: 4,
                top: 4,
            },
        };
    }
    return getRibbonBottomBarStylingConstants(ribbonType);
}

export function getCommandRibbonHeight(): number {
    return (
        getRibbonTopBarStylingConstants().topBarHeight +
        getRibbonBottomBarStyleConstants().bottomBarHeight
    );
}
